function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// Do not change anything in the protected area. Doing so will be detected and your commit will be rejected.

// Protected Area Start
import { Component } from 'react';
import { runEngine } from './RunEngine';
import { Message } from './Message';
import MessageEnum, { getName } from './Messages/MessageEnum';
import { Keyboard } from 'react-native';
import * as helper from './Helpers';
export class BlockComponent extends Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "isLoaded", false);
    const uuidv4 = require("uuid/v4");
    this.blockId = uuidv4();
    this.send = message => runEngine.sendMessage(this.blockId, message);
    this.subScribedMessages = [''];
    this.hideKeyboard = this.hideKeyboard.bind(this);
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  receive(from, message) {}
  async componentDidMount() {
    this.isLoaded = true;
  }
  async componentWillUnmount() {
    this.isLoaded = false;
    Keyboard.dismiss();
    runEngine.unSubscribeFromMessages(this, this.subScribedMessages);
  }
  toggleState(objectID) {
    this.changeState(objectID, !Boolean(this.getState(objectID)));
  }
  changeState(objectID, value) {
    switch (objectID) {
      default:
        console.log("changeState::Not Confifured for " + objectID);
    }
  }
  getState(objectID) {
    var testString = '';
    switch (objectID) {
      case 'testBoolTrue':
        return true;
      case 'testBoolFalse':
        return false;
      case 'testString':
        return testString;
      default:
        console.log("changeState::Not Confifured for " + objectID);
        return null;
    }
  }
  processOnClickMessage(messageID) {
    let value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    switch (messageID) {
      default:
        console.log("processOnClickMessage::Not Configured for " + messageID);
    }
  }
  showAlert(title, error, btnPositiveText, btnPositiveMessage, btnNegativeText, btnNegativeMessage, btnNeutralText, btnNeutralMessage) {
    Keyboard.dismiss();
    if (!btnPositiveText && !btnNegativeText && !btnNeutralText) {
      btnPositiveText = 'Ok';
    }
    const alertMsg = new Message(getName(MessageEnum.AlertMessage));
    alertMsg.addData(getName(MessageEnum.AlertTitleMessage), title);
    alertMsg.addData(getName(MessageEnum.AlertBodyMessage), error);
    alertMsg.addData(getName(MessageEnum.NavigationPropsMessage), this.props);
    alertMsg.addData(getName(MessageEnum.NavigationPropsMessage), this.props);
    alertMsg.addData(getName(MessageEnum.AlertButtonPositiveText), btnPositiveText);
    alertMsg.addData(getName(MessageEnum.AlertButtonNegativeText), btnNegativeText);
    alertMsg.addData(getName(MessageEnum.AlertButtonNeutralText), btnNeutralText);
    alertMsg.addData(getName(MessageEnum.AlertButtonPositiveMessage), btnPositiveMessage);
    alertMsg.addData(getName(MessageEnum.AlertButtonNegativeMessage), btnNegativeMessage);
    alertMsg.addData(getName(MessageEnum.AlertButtonNeutralMessage), btnNeutralMessage);
    runEngine.sendMessage(alertMsg.id, alertMsg);
  }
  parseApiErrorResponse(responseJson) {
    if (!responseJson || !responseJson.errors) {
      return;
    }
    const errors = responseJson.errors;
    let allerrors = '';
    errors.map(object => {
      const newLocal = JSON.stringify(object);
      JSON.parse(newLocal, (key, value) => {
        if (value.length > 0) {
          if (allerrors.length <= 0) {
            allerrors = value;
          } else {
            allerrors = "".concat(allerrors, "{\n}").concat(value);
          }
        }
      });
    });
    this.showAlert('Error', allerrors);
  }
  isPlatformWeb() {
    return helper.getOS() === 'web';
  }
  isPlatformiOS() {
    return helper.getOS() === 'ios';
  }
  isPlatformAndroid() {
    return helper.getOS() === 'android';
  }
  parseApiCatchErrorResponse(errorReponse) {
    if (errorReponse) {
      this.showAlert('Error', JSON.stringify(errorReponse).replace(new RegExp('"', 'g'), ''));
    }
  }
  hideKeyboard() {
    if (!this.isPlatformWeb()) {
      Keyboard.dismiss();
    }
  }
}

// Protected Area End